import SubcategoryPage from '@/components/template/SubcategoryPage';

const PiegamiStool = () => {
  const products = [
    {
      title: "Piegami Stool Basic",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/piegami-stool-basic"
    },
    {
      title: "Piegami Stool Deluxe",
      imageSrc: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80",
      url: "/proizvodi/piegami-stool-deluxe"
    },
    {
      title: "Piegami Stool Premium",
      imageSrc: "https://images.unsplash.com/photo-1579656381253-c2e57a7d7c81?auto=format&fit=crop&q=80",
      url: "/proizvodi/piegami-stool-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Piegami Stool"
      description="Zložljivi in elegantni Piegami stolčki, praktična rešitev za vsak prostor."
      heroImage="https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default PiegamiStool;